/**
 * @file
 * The Clear all behavior (berTags.components.clearAll): one confirmation,
 * one Undo and one set of messages for every widget that offers it.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { announce } = berTags.util;

  // Behavior only, not the button: the widgets build that themselves (the
  // tags one is a plain button wired to the confirm popover, the tile ones
  // go through ui.button so they keep firing ber-ui:build:button).
  //
  // opts:
  //   label()      the field label, interpolated into every message
  //   undo         {enabled, seconds}
  //   snapshot()   the current value array, read before clearing
  //   apply(next)  install a value array and re-render; called with [] to
  //                clear and with the snapshot to undo, so whatever a
  //                widget must do on both (save, re-sync, refocus) lives
  //                here once
  //
  // Returns {options, run}: `options` builds the confirm popover's config
  // (ui.button takes it as its `confirm` option as-is), `run` is the
  // click handler to use once confirmed.
  components.clearAll = ({ label, undo, snapshot, apply }) => {
    const options = () => ({
      message: Drupal.t('Clear all @label?', { '@label': label() }),
      hint: Drupal.t('References are only removed when the form is saved.'),
      yes: Drupal.t('Clear'),
    });

    const run = () => {
      // Snapshot BEFORE clearing: this array is what Undo puts back.
      const cleared = snapshot();
      apply([]);
      announce(
        Drupal.t('All @label references cleared', { '@label': label() }),
      );
      if (!undo.enabled || !cleared.length) {
        return;
      }
      berTags.undo.open({
        message: Drupal.t('All @label cleared.', { '@label': label() }),
        seconds: undo.seconds,
        onUndo: () => {
          apply(cleared);
          announce(Drupal.t('@label restored', { '@label': label() }));
        },
      });
    };

    return { options, run };
  };
})(Drupal);
